// vietnamV2Language.ts
// ─── Astria Vietnam v2 — EN/VI language ──────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): VI when
// that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../../utils/appLanguage";

export type VietnamV2Lang = "en" | "vi";

const SUPPORTED: readonly VietnamV2Lang[] = ["en", "vi"];
const ALIASES: Partial<Record<string, VietnamV2Lang>> = {};

const resolve = (appLanguage: string): VietnamV2Lang =>
  pickLanguage(appLanguage, SUPPORTED, ALIASES);

export const getVietnamV2Lang = (): VietnamV2Lang => resolve(getAppLanguage());

export function useVietnamV2Language(): VietnamV2Lang {
  return resolve(useAppLanguage());
}
